export default "__VITE_ASSET__22fb732a__"